import { isAuthenticated, logout } from './authService';
import { hasModule, isAlumnoProfile } from './permissionService';
import { routeSecurityRegistry, publicPaths } from '../security/RouteSecurityRegistry';

function splitPath(pathname) {
  return pathname.replace(/\/+$/, '').split('/').filter(Boolean);
}

function matchRoutePattern(pattern, pathname) {
  const patternParts = splitPath(pattern);
  const pathParts = splitPath(pathname);

  if (patternParts.length !== pathParts.length) {
    return false;
  }

  for (let i = 0; i < patternParts.length; i += 1) {
    const segment = patternParts[i];
    if (segment.startsWith(':')) {
      continue;
    }
    if (segment.toLowerCase() !== pathParts[i].toLowerCase()) {
      return false;
    }
  }

  return true;
}

export function resolveRouteRule(pathname) {
  const normalized = pathname || '/';
  const exact = routeSecurityRegistry.find(
    (r) => r.path === normalized || (r.exact && r.path === normalized)
  );
  if (exact) {
    return exact;
  }

  return (
    routeSecurityRegistry.find((r) => matchRoutePattern(r.path, normalized)) || {
      path: '*',
      access: 'Administrativo',
      modules: [],
      component: 'Unknown',
      testCoverage: 'deny-by-default',
    }
  );
}

export function canAccessRoute(pathname) {
  const rule = resolveRouteRule(pathname);

  if (rule.access === 'Public') {
    return true;
  }

  if (!isAuthenticated()) {
    return false;
  }

  if (rule.access === 'Authenticated') {
    return true;
  }

  if (rule.access === 'Administrativo') {
    if (isAlumnoProfile()) {
      return false;
    }
    if (rule.modules.length === 0) {
      return false;
    }
    return rule.modules.some((m) => hasModule(m));
  }

  if (rule.access === 'Alumno') {
    if (!isAlumnoProfile()) {
      return false;
    }
    return rule.modules.some((m) => hasModule(m));
  }

  return false;
}

export function denyRouteAccess() {
  logout();
}

export function isPublicPath(pathname) {
  if (pathname === '/' || publicPaths.includes(pathname)) {
    return true;
  }
  return false;
}
